import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearnMic = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 9,
		y: 3,
		width: 6,
		height: 11,
		rx: 3
	}), /* @__PURE__ */ _jsx("path", { d: "M5 11a7 7 0 0 0 14 0M12 18v3M9 21h6" })]
});
export default SvgLearnMic;
